import axios from "axios";
import Cookies from "js-cookie";

const dev = "http://172.16.1.191:8989/api/";
const production = "https://webapps.coperdia.com.br/app_curriculos/api/";

const api = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? production : production,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

api.interceptors.request.use(
  async (config) => {
    const session = Cookies.get("web_curriculos");
    if (session) {
      const ses = JSON.parse(session);
      config.headers.Authorization = "Bearer " + ses?.token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default api;
